import { useLocation } from "react-router-dom";
import { type FC, type ReactNode, useContext, useMemo } from "react";

import { ProductionContext } from "@/contexts/production";
import type { NavbarItem } from "@/components/navbar/types";
import { SelectMachineGroup } from "@/views/production/select-scope/select-machine-group";
import SelectProductionGroup from "@/views/production/select-scope/select-production-group";

interface RequireCurrentMachineGroupProps {
	readonly children: ReactNode;
	readonly tabs?: NavbarItem[];
}

const RequireCurrentMachineGroup: FC<RequireCurrentMachineGroupProps> = ({ children, tabs }) => {
	const { currentMachineGroup, currentProductionGroup } = useContext(ProductionContext);
	const { pathname } = useLocation();
	const currentTab = useMemo(() => tabs?.find((tab) => pathname.includes(tab.link)), [pathname, tabs]);
	const isPGSelectionEnabled = currentTab?.selectableWithPg ?? false;

	if (!currentMachineGroup && !(isPGSelectionEnabled && currentProductionGroup !== null)) {
		return <SelectMachineGroup isPGSelectionEnabled={isPGSelectionEnabled} />;
	}

	if (!currentProductionGroup) {
		return <SelectProductionGroup />;
	}

	return children;
};

export default RequireCurrentMachineGroup;
